import { render, staticRenderFns } from "./EquipamentTypesConfigs.vue?vue&type=template&id=0b67e9d4&"
import script from "./EquipamentTypesConfigs.vue?vue&type=script&lang=js&"
export * from "./EquipamentTypesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports